import { render, staticRenderFns } from "./ContractMarketingDetails.vue?vue&type=template&id=c052e78e&scoped=true&"
import script from "./ContractMarketingDetails.vue?vue&type=script&lang=js&"
export * from "./ContractMarketingDetails.vue?vue&type=script&lang=js&"
import style0 from "./ContractMarketingDetails.vue?vue&type=style&index=0&id=c052e78e&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c052e78e",
  null
  
)

export default component.exports